export const create = (self, evaluationData) => {
  const ROWS_ON_PAGE = 11;
  let tocSlides = [];
  let usedTocSlides = new Set(); // Track which slides are actually used
  const firstSlide = self.pptx.addSlide('Slide master');
  firstSlide.tableOfContents = true; // Mark as TOC slide for cleanup
  tocSlides.push(firstSlide);
  usedTocSlides.add(0); // First slide is always used
  let tocRowsCount = 0;
  evaluationData.report.assessors.forEach((assossorId) => {
    let assessorGroupsCount = 0;
    evaluationData.report.groups.forEach((groupId) => {
      let rowSize = 1;
      switch (assessorGroupsCount) {
        case 0:
          rowSize = 1;
          break;
        case 1:
          rowSize = 0.9;
          break;
        default:
          rowSize = 0.7;
          break;
      }
      if (evaluationData.groups[groupId].assessor_list.includes(assossorId)) {
        assessorGroupsCount += rowSize;
      }
    });
    tocRowsCount += assessorGroupsCount;
  });
  tocRowsCount = Math.round(tocRowsCount);
  if (tocRowsCount > ROWS_ON_PAGE) {
    // Calculate total pages needed, minus the first page we already created
    let additionalPagesNeeded = Math.ceil(tocRowsCount / ROWS_ON_PAGE) - 1;
    for (let i = 0; i < additionalPagesNeeded; i++) {
      const slide = self.pptx.addSlide('Slide master');
      slide.tableOfContents = true; // Mark all TOC slides so we can identify and clean them up later
      tocSlides.push(slide);
    }
  }

  const calcGeneratePageTableOfContents = (y, toc, content, page = 1) => {
    for (var i = 0; i < toc.length; i++) {
      if (toc[i] === undefined) continue;
      y += 0.5;
      if (toc[i].children.length > 1) {
        for (var j = 0; j < toc[i].children.length; j++) {
          if (j === 0) {
            y += 0.42;
          } else {
            y += 0.33;
          }
        }
      }

      if (y > 8) {
        page += 1;
        y = content !== null && content !== '' ? 1.95 : 1.45;
      }
    }
    return page;
  };
  const generate = (slide, y, toc, content, calcTablePage = 0, slideNumber = 0) => {
    for (var i = 0; i < toc.length; i++) {
      if (toc[i] === undefined) continue;

      y += 0.5;

      if (y > 8) {
        // calcTablePage += 1
        let slide = tocSlides[slideNumber + 1]; //self.pptx.addNewSlide('Slide master');
        // Safety check - this should never happen if initial calculation is correct
        if (!slide) {
          console.error('Not enough TOC slides pre-created. This is a bug in the calculation.');
          return;
        }
        usedTocSlides.add(slideNumber + 1); // Mark this slide as used
        slide.tableOfContents = true;
        slide.addText(app.$t('Table of Contents'), self.styleOptions.slideHeader);

        // if executive summary hasn't been filled out, do not show
        // if (content !== null && content !== '') {
        //     slide.addText(
        //         app.$t('Executive Summary'), {
        //         x: 0.5,
        //         y: 1.95,
        //         h: 1,
        //         color: '000000',
        //         fontSize: 16,
        //         fontFace: 'Arial',
        //         bold: true
        //     }
        //     );
        //
        //     slide.addText(
        //         '2', {
        //         x: 7.5,
        //         y: 1.95,
        //         h: 1,
        //         color: '000000',
        //         fontSize: 16,
        //         fontFace: 'Arial',
        //         bold: true
        //     }
        //     );
        // }

        let y = 1.45; // (content !== null && content !== '') ? 1.95 : 1.45;
        let nextToc = toc.slice(i);
        generate(slide, y, nextToc, content, calcTablePage, slideNumber + 1);
        return;
      }

      slide.addText(app.$t(toc[i].title), {
        y: y,
        ...self.styleOptions.tocAssessorTitle,
      });

      slide.addText(toc[i].page + 1, {
        // + calcTablePage, {
        y: y,
        ...self.styleOptions.tocAssessorPage,
      });

      if (toc[i].children.length > 1) {
        for (var j = 0; j < toc[i].children.length; j++) {
          if (j === 0) {
            y += 0.42;
          } else {
            y += 0.33;
          }

          slide.addText(toc[i].children[j].title, {
            y: y,
            ...self.styleOptions.tocGroupTitle,
          });

          slide.addText(toc[i].children[j].page + 1, {
            // + calcTablePage, {
            y: y,
            ...self.styleOptions.tocGroupPage,
          });
        }
      }
    }
  };

  return (self.tableOfContents = function (toc, title, content) {
    let slide = tocSlides[0];
    slide.tableOfContents = true;
    slide.addText(app.$t('Table of Contents'), self.styleOptions.slideHeader);

    // if executive summary hasn't been filled out, do not show
    if (content !== null && content !== '') {
      slide.addText(app.$t('Executive Summary'), self.styleOptions.tocExecutiveSummaryTitle);

      slide.addText(toc[0].page, self.styleOptions.tocExecutiveSummaryPage);
    }

    var y = content !== null && content !== '' ? 1.95 : 1.45;
    const calcTablePage = calcGeneratePageTableOfContents(y, toc, content);
    generate(slide, y, toc, content, calcTablePage, 0);

    // Remove unused TOC slides from the presentation
    // Loop backwards to safely remove slides without index shifting issues
    for (let i = self.pptx.slides.length - 1; i >= 0; i--) {
      const slide = self.pptx.slides[i];
      // Check if this is a TOC slide
      if (slide.tableOfContents) {
        // Find its index in our tocSlides array
        const tocIndex = tocSlides.indexOf(slide);
        // If it's in our TOC slides array but wasn't used, remove it
        if (tocIndex !== -1 && !usedTocSlides.has(tocIndex)) {
          self.pptx.slides.splice(i, 1);
        }
      }
    }

    return true;
  });
};
